import { render, staticRenderFns } from "./OrderBilling.vue?vue&type=template&id=3067d6ce&scoped=true"
import script from "./OrderBilling.vue?vue&type=script&lang=js"
export * from "./OrderBilling.vue?vue&type=script&lang=js"
import style0 from "./OrderBilling.vue?vue&type=style&index=0&id=3067d6ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3067d6ce",
  null
  
)

export default component.exports